module.exports = __webpack_public_path__ + "static/media/venue_carousel_landing.943a35c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/venue_carousel_landing.png
// module id = 1153
// module chunks = 0